import webkitLineClamp from "webkit-line-clamp";

(function ($) {
        jQuery.fn.shopSearch = function (options) {
            var $this = this;
            $this.html('<div class="progress" style="margin-top: 1rem;">' +
                '<div class="progress-bar progress-bar-striped bg-primary progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style=" width:100%;">Loading...</div>' +
                '</div>');

            var defaults = {
                url: '/?standalone=Avency.Nwd.Base:Content.ProductSearch&searchterm={searchTerm}'
            };
             //get Settings from Data attributes
            var data = $this.data();
            Object.keys(data).forEach(function (key) {
                let newKey = key.replace(/shopSearch/, '');
                if (newKey !== key) {
                    newKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);
                    data[newKey] = data[key];
                }
                delete data[key];
            });
            // set Options
            var opts = $.extend({}, defaults, data, options);

            var searchTerm = new RegExp('[\?&]' + 'search' + '=([^&#]*)').exec(window.location.href);
            if (searchTerm !== null) {
                searchTerm = searchTerm[1] || 0;
                let getData = function () {
                    $.ajax({
                        url: opts.url.replace('{searchTerm}', searchTerm),
                        processData: true,
                        dataType: "html",
                        complete: function (response) {
                            let $productHtml = $(response.responseText);
                            $this.html('');
                            $this.append($productHtml);
                            $('.croppedLines').each(function () {
                                var lines = $(this).data('linecrop');
                                webkitLineClamp($(this)[0], lines);
                            });
                            $(document).trigger('update-annotations');

                            const event = new Event('plandent.reinit.bootstrapTabs');
                            document.dispatchEvent(event);
                        }
                    })
                };
                getData();
            }
        }
    }
)(jQuery);

$('[data-shop-search=init]').each(function(){
    $(this).shopSearch();
});
